import { BASE_URL } from '@/config'

export async function createResponse(responseData) {
  console.log('Response data:', responseData)
  try {
    const response = await fetch(`${BASE_URL}/response/register`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(responseData),
    })

    if (!response.ok) {
      const errorData = await response.json()
      throw new Error(errorData.message || 'Erro ao criar resposta')
    }

    return await response.json()
  } catch (error) {
    console.error('Erro ao criar resposta:', error)
    throw error
  }
}

export async function getResponses() {
  try {
    const response = await fetch(`${BASE_URL}/response/responses`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    })

    if (!response.ok) {
      const errorData = await response.json()
      throw new Error(errorData.message || 'Erro ao buscar respostas')
    }

    return await response.json()
  } catch (error) {
    console.error('Erro ao buscar respostas:', error)
    throw error
  }
}

export async function getResponsesByEmployeeId(employeeId) {
  try {
    const response = await fetch(
      `${BASE_URL}/response/employee/${employeeId}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    if (!response.ok) {
      const errorData = await response.json()
      throw new Error(errorData.message || 'Erro ao buscar respostas')
    }

    return await response.json()
  } catch (error) {
    console.error('Erro ao buscar respostas:', error)
    throw error
  }
}
